// Add your custom JS here.


// Define the function to add classes based on input value
function updateClasses(inputField) {
    const inputLabel = inputField.closest(".form-row").querySelector('label');
    const inputParagraph = inputField.closest('.form-row');

    // Check if the input has a value
    if (inputField.value.trim() !== '') {
        // Add the 'cfw-label-is-floated' class to the paragraph
        inputParagraph.classList.add('cfw-label-is-floated');
        // Add the 'cfw-floatable-label' class to the label
        inputLabel.classList.add('cfw-floatable-label');
    } else {
        // Remove the classes if the input is empty
        inputParagraph.classList.remove('cfw-label-is-floated');
        inputLabel.classList.remove('cfw-floatable-label');
    }
}

// Get all elements with the class 'floatable-input'
const floatableInputs = document.querySelectorAll('.input-text');

// Run the function on page load for each input
floatableInputs.forEach(function(input) {
    updateClasses(input);
});

// Add an event listener to each input element to run the function on input change
floatableInputs.forEach(function(input) {
    input.addEventListener('input', function () {
        updateClasses(this);
    });
});